// Filter
///////////////////
import Sticky from "sticky-js";

let filterElement = document.querySelector(".filter");

if (filterElement !== null) {
  let filterWrapperElement = document.querySelector(".filter__wrapper");
  let filterSearchElement = document.querySelector(".filter__search");
  let filterTopElement = document.querySelector(".filter__top");
  let filterBottomElement = document.querySelector(".filter__bottom");
  let filterUrlAlternative = document.querySelector("[data-filter-url]");

  // Filter dropdown size
  let sizeDropdownButton = document.querySelector(".filter__size-title");
  let sizeDropdown = document.querySelector(".filter__size");

  sizeDropdownButton.addEventListener("click", (e) => {
    sizeDropdown.classList.toggle("open");
    filterElement.classList.add("overflow-initial");
  });

  // Filter mobile dropdown
  let mobileDropdown = document.querySelectorAll(".js-mobile-dropdown");

  Array.from(mobileDropdown).forEach((el) => {
    el.querySelector("[data-dropdown-button]").addEventListener(
      "click",
      (e) => {
        if (e.target.closest(".filter__others-box-tooltip") === null) {
          e.currentTarget.parentNode
            .closest(".js-mobile-dropdown")
            .classList.toggle("open");
        }
      },
    );
  });

  let filterEl = document.querySelector(".filter");
  let mobileFilterButtonOpen = document.querySelector(".js-open-filter");
  let menuIconButton = document.querySelector(".menu-icon");
  let menuText = menuIconButton.querySelector(".menu-icon__text");
  let menuMobileContainer = document.querySelector(".navigation-mobile");

  mobileFilterButtonOpen.addEventListener("click", () => {
    filterElement.classList.add("open");
    menuMobileContainer.classList.add("menu-active");
    document.body.classList.add("body-hidden-filter");
    menuIconButton.classList.add("open");
    menuText.textContent = "Close";
    initFilterMobileHeight();
  });

  // Filter mobile | tablet height wrapper
  let initFilterMobileHeight = () => {
    let mediaQuery = window.matchMedia("(min-width: 768px)");
    let filterTopHeight = filterTopElement.offsetHeight + 20;
    let filterSearchHeight = filterSearchElement.offsetHeight + 16;
    let filterBottomHeight = filterBottomElement.offsetHeight + 44 + 12;

    if (mediaQuery.matches) {
      filterWrapperElement.removeAttribute("style");
    } else {
      filterWrapperElement.style.height = `${window.innerHeight - (filterTopHeight + filterSearchHeight + filterBottomHeight)}px`;
    }
  };

  window.addEventListener("orientationchange", function (event) {
    initFilterMobileHeight();
  });

  window.addEventListener("resize", function (event) {
    initFilterMobileHeight();
  });

  let allInputsFilter = document.querySelectorAll(".filter input");

  let setFilter = (dataName) => {
    let params = new URLSearchParams(window.location.search);
    // Type
    params.delete("type");
    let type = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "type");
    });

    type = type.map((item) => {
      return item.value;
    });

    if (type.length !== 0) {
      params.set("type", type.toString());
    }

    // Gender
    params.delete("gender");
    let gender = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "gender");
    });

    gender = gender.map((item) => {
      return item.value;
    });

    if (gender.length !== 0) {
      params.set("gender", gender.toString());
    }

    // Collection
    params.delete("collection");
    let collection = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "collection");
    });

    collection = collection.map((item) => {
      return item.value;
    });

    if (collection.length !== 0) {
      params.set("collection", collection.toString());
    }

    // Material
    params.delete("material");
    let material = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "material");
    });

    material = material.map((item) => {
      return item.value;
    });

    if (material.length !== 0) {
      params.set("material", material.toString());
    }

    // Size
    params.delete("size");
    let size = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "size");
    });

    size = size.map((item) => {
      return item.value;
    });

    if (size.length !== 0) {
      params.set("size", size.toString());
    }

    // Size Detail
    params.delete("size_detail");
    let size_detail = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "size_detail");
    });

    size_detail = size_detail.map((item) => {
      return item.value;
    });

    if (size_detail.length !== 0) {
      params.set("size_detail", size_detail.toString());
    }

    // Shape
    params.delete("shape");
    let shape = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "shape");
    });

    shape = shape.map((item) => {
      return item.value;
    });

    if (shape.length !== 0) {
      params.set("shape", shape.toString());
    }

    // Color
    params.delete("color");
    let color = Array.from(allInputsFilter).filter((item) => {
      return item.checked & (item.name === "color");
    });

    color = color.map((item) => {
      return item.value;
    });

    if (color.length !== 0) {
      params.set("color", color.toString());
    }

    // Name
    try {
      let name = params.get("name").split(",");
      if (name.length !== 0) {
        const indexName = name.indexOf(dataName);
        name.splice(indexName, 1);
      }
      params.delete("name");

      if (name.length !== 0) {
        params.set("name", name.toString());
      }
    } catch (err) {
      console.log(err);
    }

    if(filterUrlAlternative) {
      const filterUrl = filterUrlAlternative.dataset.filterUrl;
      window.history.pushState(filterUrl, "Glasses", `/${filterUrl}`);
      window.location.search = params.toString().replaceAll("%2C", ",");
    } else {
      window.history.pushState("eyeglasses", "Glasses", "/eyeglasses");
      window.location.search = params.toString().replaceAll("%2C", ",");
    }

  };

  let tagListItems = document.querySelectorAll(".filter__tag-button");

  let removeParameter = (item) => {
    let dataName = item.dataset.name;
    let uncheckedInput = document.getElementById(dataName);

    try {
      uncheckedInput.checked = false;
    } catch (err) {
      console.log(err);
    }

    item.remove();

    let mediaQuery = window.matchMedia("(min-width: 768px)");

    if (mediaQuery.matches) {
      setFilter(dataName);
    }
  };

  let initFilterActiveDot = () => {
    Array.from(document.querySelectorAll(".js-mobile-dropdown")).forEach(
      (item) => {
        item.querySelector("* > button").classList.remove("active");
      },
    );

    let filterAllState = Array.from(
      document.querySelectorAll(".filter input"),
    ).filter((item) => {
      return item.checked === true;
    });

    if (filterAllState.length !== 0) {
      mobileFilterButtonOpen.classList.add("active");
      // desktopFilterButtonOpen.classList.add("active");

      filterAllState.forEach((item) => {
        item.parentNode
          .closest(".js-mobile-dropdown")
          .querySelector("* > button")
          .classList.add("active");
      });
    } else {
      mobileFilterButtonOpen.classList.remove("active");
    }
  };

  initFilterActiveDot();

  let applyFilterButton = document.querySelector(".js-apply-filter");

  applyFilterButton.addEventListener("click", () => {
    setFilter();
  });

  Array.from(allInputsFilter).forEach((item) => {
    item.addEventListener("change", (e) => {
      if (e.target.className !== "input-search__input") {
        applyFilterButton.removeAttribute("disabled");

        let mediaQuery = window.matchMedia("(min-width: 768px)");
        initFilterActiveDot();
        if (mediaQuery.matches) {
          setFilter();
        }
      }
    });
  });

  Array.from(tagListItems).forEach((item) => {
    item.addEventListener("click", (e) => {
      removeParameter(e.currentTarget);
    });
  });

  try {
    let resetFilterButton = document.querySelectorAll(".js-reset-filter");

    let resetFilter = () => {
      Array.from(allInputsFilter).forEach((item) => {
        item.checked = false;
        setFilter();
      });
    };

    Array.from(resetFilterButton).forEach((item) => {
      item.addEventListener("click", (e) => {
        resetFilter();
      });
    });
  } catch (err) {
    console.log(err);
  }
}

const mediaQueryFilter = window.matchMedia(
  "(min-width: 1200px) and (min-height: 1000px)",
);
const stickyFilter = document.querySelector(".js-filter__wrapper");
let sticky = null;

if (stickyFilter && mediaQueryFilter.matches) {
  sticky = new Sticky(".js-filter__wrapper");
}

window.addEventListener("resize", () => {
  if (sticky !== null) {
    sticky.destroy();
    sticky = null;
  }

  if (stickyFilter && mediaQueryFilter.matches) {
    sticky = new Sticky(".js-filter__wrapper");
  }
});
